import { combineReducers } from 'redux';
import { generalConstants } from '../constants';

let localSetting = JSON.parse(localStorage.getItem('setting'));
const initialStateSetting = localSetting
  ? { loading: false, loaded: true, data: localSetting }
  : {};

function setting(state = initialStateSetting, action) {
  switch (action.type) {
    case generalConstants.SETTING_REQUEST:
      return {
        loading: true
      };
    case generalConstants.SETTING_SUCCESS:
      return {
        id: action.data.id,
        loaded: true,
        data: action.data.data
      };
    case generalConstants.SETTING_FAILURE:
      return {};
    default:
      return state;
  }
}

function content(state = {}, action) {
  switch (action.type) {
    case generalConstants.CONTENT_REQUEST:
      return {
        loading: true
      };
    case generalConstants.CONTENT_SUCCESS:
      return {
        id: action.data.id,
        loaded: true,
        data: action.data.data
      };
    case generalConstants.CONTENT_FAILURE:
      return {};
    case generalConstants.POST_CONTENT_REQUEST:
      return {
        saving: true
      };
    case generalConstants.POST_CONTENT_SUCCESS:
      return {};
    case generalConstants.POST_CONTENT_FAILURE:
      return {};
    default:
      return state;
  }
}

function subcontent(state = {}, action) {
  switch (action.type) {
    case generalConstants.SUBCONTENT_REQUEST:
      return {
        loading: true
      };
    case generalConstants.SUBCONTENT_SUCCESS:
      return {
        id: action.data.id,
        loaded: true,
        data: action.data.data
      };
    case generalConstants.SUBCONTENT_FAILURE:
      return {};
    default:
      return state;
  }
}

function notification(state = {}, action) {
  switch (action.type) {
    case generalConstants.NOTIFICATION_REQUEST:
      return {
        loading: true,
        data: action.data
      };
    case generalConstants.NOTIFICATION_SUCCESS:
      return {
        loaded: true,
        data: action.data
      };
    case generalConstants.NOTIFICATION_FAILURE:
      return {};
    default:
      return state;
  }
}

function upload(state = {}, action) {
  switch (action.type) {
    case generalConstants.UPLOAD_REQUEST:
      return {
        uploading: true,
        data: action.data
      };
    case generalConstants.UPLOAD_SUCCESS:
      return {
        uploaded: true,
        data: action.data
      };
    case generalConstants.UPLOAD_SAVED:
      return {
        uploaded: true,
        edited: true,
        data: action.data
      };
    case generalConstants.UPLOAD_CLEARED:
      return {};
    case generalConstants.UPLOAD_FAILURE:
      return {};
    default:
      return state;
  }
}

function file(state = {}, action) {
  switch (action.type) {
    case generalConstants.FILES_REQUEST:
      return {
        loading: true
      };
    case generalConstants.FILES_SUCCESS:
      return {
        idFetch: action.dataFetch.data,
        loaded: true,
        dataFetch: action.dataFetch.data
      };
    case generalConstants.FILES_FAILURE:
      return {};
    case generalConstants.POST_FILES_REQUEST:
      return {
        saving: true
      };
    case generalConstants.POST_FILES_SUCCESS:
      return {};
    case generalConstants.POST_FILES_FAILURE:
      return {};
    default:
      return state;
  }
}

export const general = combineReducers({
  content,
  subcontent,
  setting,
  upload,
  notification,
  file
});



// WEBPACK FOOTER //
// ./src/reducers/general.reducer.js